import * as React from 'react'
import { SwipeableDrawer } from '@mui/material'
import { styled } from '../../theme/styled'
import { BottomDrawerProps } from './BottomDrawerProps'

const DrawerContainer = styled(SwipeableDrawer)`
  & .MuiBackdrop-root {
    background: ${(p) => p.theme.av8.backdropColor};
  }
  & .MuiPaper-root {
    background: ${(p) => p.theme.av8.background};
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
`

const Divider = styled.div`
  background: ${(p) => p.theme.av8.dividerColor};
  border-radius: 4px;
  width: 42px;
  height: 4px;
  margin: 12px auto 12px auto;
  padding-left: 1rem;
`

const BottomDrawer = (props: BottomDrawerProps) => {
  const { open, onClose, onOpen, children } = props

  const iOS = React.useMemo(() => {
    return typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)
  }, [])

  return (
    <React.Fragment>
      <DrawerContainer
        anchor={'bottom'}
        open={open}
        onClose={onClose}
        onOpen={onOpen}
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
      >
        <Divider />
        {children}
      </DrawerContainer>
    </React.Fragment>
  )
}

export default BottomDrawer
